import * as React from 'react';
import { Text, Box, Divider, Button } from 'wix-style-react';
import { composer } from '../../component-decorators/composer';
import { CounterHolidaySale } from './counter-holiday-sale';
import s from './header-holiday.scss';
import { biLogger } from '../../bi';
export var HeaderHolidaySale = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var onClick = _a.onClick, opacity = _a.opacity, t = _a.t, experiments = _a.experiments, home = _a.home, origin = _a.origin, skin = _a.skin, msId = _a.msId, referral = _a.referral;
    var showHolidaySale = experiments.enabled('specs.marketplace.blackFridaySale');
    var showHolidayContent = experiments.enabled('specs.marketplace.blackFridaySaleContent');
    var ctaText = showHolidayContent
        ? 'home.holidaySale.header.cta-button-b'
        : 'home.holidaySale.header.cta-button';
    var manageApps = skin === 'manage-apps';
    var position = manageApps ? 'initial' : 'sticky';
    var width = !manageApps ? '100%' : 'auto';
    var borderRadius = manageApps ? '8px' : '0px';
    var padding = home && origin === 'bizmgr'
        ? '12px 89px 12px 48px'
        : manageApps
            ? '12px 24px'
            : '12px 48px';
    var inStandalone = origin === 'standalone';
    var top = inStandalone && skin === 'all-pages' ? '60px' : 0;
    if (showHolidaySale) {
        return (React.createElement("div", { style: { width: width, position: position, top: top, zIndex: 8 } },
            React.createElement(Box, { align: manageApps ? 'left' : 'center', verticalAlign: 'middle', border: "1px solid", padding: padding, backgroundColor: '#0b132b', width: !manageApps ? '100%' : 'auto', opacity: opacity, borderRadius: borderRadius, boxSizing: 'border-box' },
                React.createElement(Title, { title: t('home.holidaySale.title'), subtitle: t('home.holidaySale.header.subtitle') }),
                React.createElement(CounterHolidaySale, null),
                onClick && (React.createElement(SaleButton, { ctaText: t(ctaText), onClick: onClick, msId: msId, referral: referral, showHolidayContent: showHolidayContent })),
                React.createElement(Box, { height: '42px', margin: '0 24px' },
                    React.createElement(Divider, { direction: 'vertical', className: s.dividerColor })),
                React.createElement(Disclaimer, { text: t('home.holidaySale.disclaimer') }))));
    }
    return null;
});
var Title = function (_a) {
    var title = _a.title, subtitle = _a.subtitle;
    return (React.createElement(Box, { direction: 'vertical', marginRight: '24px' },
        React.createElement(Text, { weight: "bold", className: s.holidayColor, style: { color: '#dd4dae' }, size: "small" }, title),
        React.createElement(Text, { skin: "standard", light: true, weight: "bold", size: "small" }, subtitle)));
};
var SaleButton = function (_a) {
    var ctaText = _a.ctaText, onClick = _a.onClick, msId = _a.msId, referral = _a.referral, showHolidayContent = _a.showHolidayContent;
    return (React.createElement(Box, { marginLeft: '24px' },
        React.createElement(Button, { className: showHolidayContent ? s.saleButtonNew : s.saleButton, size: 'small', onClick: function () {
                // tslint:disable-next-line: no-floating-promises
                biLogger.appMarketSaleCheckAllSaleAppsHeaderClick({
                    msid: msId,
                    sale_name: 'nov21',
                    slug_id: 'pre-holiday-sale',
                    referral_tag_type: referral,
                });
                onClick();
            } }, ctaText)));
};
var Disclaimer = function (_a) {
    var text = _a.text;
    return (React.createElement(Text, { size: "tiny", weight: "thin", className: s.disclaimer, light: true }, text));
};
//# sourceMappingURL=header-holiday-sale.js.map